import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { SECOND_TO_MS } from '../../utils/constants'
import Arrows from './Arrows'
import Dots from './Dots'
import Slides from './Slides'

const CarouselStyled = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  overflow: hidden;
  position: relative;
`

const Carousel = ({
  autoplaySpeed = 8000,
  width = '100%',
  arrows = true,
  dots = true,
  length = 0,
  freezingTime = 0,
  children,
}: {
  autoplaySpeed: number
  width?: string
  arrows?: boolean
  dots?: boolean
  length: number
  freezingTime: number
  children?: React.ReactNode
}) => {
  const [step, setStep] = useState(0)
  const [freeze, setfreeze] = useState(true)
  const [newLength] = useState(length || React.Children.count(children))

  const changeStep = useCallback(
    (value: number) => {
      setStep((prevStep) => {
        const newStep = prevStep + value
        if (newStep >= newLength) {
          return 0
        }
        if (newStep < 0) {
          return newLength - 1
        }
        return newStep
      })
    },
    [newLength]
  )

  useEffect(() => {
    const refFreeze = setTimeout(
      () => setfreeze(false),
      SECOND_TO_MS * freezingTime
    )
    return () => clearTimeout(refFreeze)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!freeze) {
        changeStep(1)
      }
    }, autoplaySpeed)
    return () => clearTimeout(timer)
  }, [freeze, changeStep, autoplaySpeed])

  return (
    <CarouselStyled width={width}>
      <Slides length={length} step={step}>
        {children}
      </Slides>
      {arrows && <Arrows onClick={changeStep} />}
      {dots && (
        <Dots length={length} step={step} onClick={(index) => setStep(index)} />
      )}
    </CarouselStyled>
  )
}

export default Carousel
